<template>
  <div id="forgotpw-wrapper" :class="{'open': open}">
    <div id="forgot-box" class="container inner-container">
      <h3>{{ cpLang('login.forgot') }}</h3>
      <div class="row overflow-visible">
        <div class="col-xl-4 col-lg-12 col-xs-12 forgot-tips">
          <div v-if="!process">
          <p>{{ forgotIntroMsg }}</p>
          </div>
          <div v-else class="text-left">
            <p v-html="cpLang('login.forgot_done', {email} )" />
            <button @click="closeAll" class="btn btn-primary">
              Close
            </button>
          </div>
        </div>
        <div class="col-1 d-none d-lg-block d-xl-none">
      &nbsp;
</div>
        <div class="col-3 col-xs-12">
          <form :class="process ? 'd-none' : 'process'" @submit.prevent="toggleValClass" novalidate>
            <input
              id="forgot-mail-box"
              v-model="mail"
              type="text"
              class="form-control"
              placeholder="Email Address"
              required
            >
            <recaptcha
              @error="onError"
              @success="onSuccess"
              @expired="onExpired"
            />
            <div class="l-flex">
              <input @click="goToLogin" type="button" value="Back" class="btn back">
              <button
                @click="forgotPassword"
                type="submit"
                class="btn btn-primary"
              >
              {{ cpLang('login.forgot_send') }}
              </button>
              <div v-show="error" class="text-danger">
                <small>{{ error }}</small>
              </div>
            </div>
          </form>
        </div>
        <div class="col-5 col-xs-12" />
        <div class="clear-both" />
      </div>
    </div>
    <div class="clear-both" />
  </div>
</template>

<script>
import commonHelper from '~/assets/js/commonHelper.js'
export default {
  components: {},
  props: {
    open: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      status: false,
      mail: '',
      lang: this.checkLang(),
      error: '',
      forgotPasswordSent: false,
      verificationCode: '',
      process: false,
      email: ''
    }
  },
  computed: {
    forgotIntroMsg: function() {
      return this.cpLang('login.forgot_intro')
    }
  },
  mounted() {
    this.$recaptcha.language = this.lang
  },
  methods: {
    goToLogin: function() {
      if (document.body.id === 'forgot-page') {
        this.$router.push({
          path: '/login'
        })
      } else {
        this.$emit('gotologin')
      }
    },
    onError (err) {
      console.log('Error happened:' + err)
    },
    onSuccess (res) {
      this.status = true
      this.verificationCode = res
      return this.verificationCode
    },
    onExpired (token) {
      this.$recaptcha.reset()
    },
    checkLang: function() {
      const curLang = this.$cpCookie.get('revampLang')
      // console.log(curLang)
      return curLang === 'undefined' ? 'en' : curLang === 'zhhk' ? 'zh-tw' : 'en'
    },
    forgotPassword: async function() {
      if (commonHelper.isEmpty(this.mail)) {
        this.error = this.cpLang('login.email_required')
        document.getElementById('forgot-mail-box').focus()
        return false
      }
      if (!commonHelper.isValidEmail(this.mail)) {
        this.error = this.cpLang('apply.email_invalid')
        document.getElementById('forgot-mail-box').focus()
        return false
      }
      if (this.verificationCode === '') {
        this.error = this.cpLang('login.recaptcha_required')
        return false
      }
      this.error = ''
      if (this.status) {
        const vm = this
        const params = { email: this.mail, hash: this.verificationCode }
        await this.$axios.post('candidate/forgotpassword', params).then(function(res) {
          console.log(res)
          if (res.data.status === 'fail') {
            vm.error = res.data.message
            vm.$recaptcha.reset()
          }
          if (res.data.status === 'success') {
            vm.email = vm.emailEncrypt(vm.mail)
            vm.process = true
            vm.mail = ''
            vm.$recaptcha.reset()
            vm.forgotPasswordSent = true
          }
        })
      }
    },
    emailEncrypt: function(email) {
      const star = '*'
      const position = email.search('@')
      const firstPart = email.substring(0, 1)
      const secondPart = star.repeat(email.substring(1, position).length)
      const mailDomain = email.substring(position)
      const mailDomainToDot = mailDomain.substring(1, mailDomain.search(/\./))
      const thirtPart = star.repeat(mailDomainToDot.length)
      const furthPart = email.substring(email.lastIndexOf('.'))
      return firstPart + secondPart + '@' + thirtPart + furthPart
    },
    closeAll: function() {
      this.process = false
      this.$emit('closeall')
    },
    toggleValClass: function(e) {
      e.target.classList.add('was-validated')
    }
  }
}
</script>

<style>
#forgotpw-wrapper .col-3.col-xs-12{
  min-height: 200px;
}
</style>
